import { Box, Button, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import CustomAlert from "../events/components/CustomAlert";
import useCustomTheme from "../../theme/useCustomTheme";


const OutagePopup = (props) => {
    const {open, setOpen} = props;
    const dispatch = useDispatch()
    const [theme ] = useCustomTheme()

    const handleClose = () => {
        setOpen(false)
       };

  return <CustomAlert
          open={open}
          handleClose={handleClose}
          width={{ xs: '400px', sm: '600px', md: '840px', lg: '880px', xl: '1200px' }}
          height={{ xs: '440px', sm: '440px', md: '460px', lg: '460px', xl: '600px' }}
      >
          <Box p={5} className="flex col j-center" sx={{ height: '100%' }}>
              <Box mb={{ xs: 1, md: 2 }} mt={1}>
              <Typography  sx={{font: 36, textAlign: 'center', fontWeight: 800, mb:2}} >Temporary Service Outage!</Typography>
               <Typography  sx={{font: 18}} >We’re sorry for the interruption — one of our cloud providers is currently experiencing a major outage. As a result, some parts of Lucihub, including video projects and Creative Copilot, may be temporarily unavailable.
                    Our team is actively working with the provider to restore full access as quickly as possible. We’ll notify you as soon as everything is back online.
                    Thank you for your patience and understanding.
                </Typography>  
                
              
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'end' }} gap={2} mt={{ xs: 1, md: 2 }} >
                  <Button variant='outlined' onClick={handleClose} style={{ borderRadius: '5px', backgroundColor: '#08231B', color: theme.palette.primary.main, textTransform: 'none', }} sx={{ fontSize: { xs: '9px', sm: '9px', md: '9px', lg: '11px', xl: '16px', }, fontWeight: 600, width: { xs: '76px', sm: '76px', md: '76px', lg: '86px', xl: '129px' }, paddingY: 0.4, }}>Close</Button>
              </Box>
          </Box>
      </CustomAlert>
}

export default OutagePopup